class CharCountTextareaController {
  constructor() {
    this._maxCount = 150; //default
  }

  $onInit() {

    if(this.maxCount && parseInt(this.maxCount, 10)){
      this._maxCount = parseInt(this.maxCount, 10);
    }
    this.countRemaining = this._maxCount;
  }

  calcRemaining() {
    this.countRemaining = this._maxCount - this.message.length;
  }

  clear() {
    this.message = '';
    this.countRemaining = this._maxCount;
  }
}

export default CharCountTextareaController;
